var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.image && _vm.image.image && _vm.image.image.fields.file
    ? _c("img", {
        class: _vm.imageClasses,
        style: _vm.maxWidth,
        attrs: {
          src: _vm.image.image.fields.file.url + _vm.sizeParams,
          alt: _vm.alt,
          type: "image/jpeg",
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }